import { render, staticRenderFns } from "./commandcenter.vue?vue&type=template&id=04a71a80&"
import script from "./commandcenter.vue?vue&type=script&lang=js&"
export * from "./commandcenter.vue?vue&type=script&lang=js&"
import style0 from "./commandcenter.vue?vue&type=style&index=0&id=04a71a80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports